var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pager"},[_c('router-link',{staticClass:"prev",class:{off: !_vm.isPrev},attrs:{"to":_vm.toPrev}},[_vm._v("BACK")]),_c('router-link',{staticClass:"next",class:{off: !_vm.isNext},attrs:{"to":_vm.toNext}},[_vm._v("NEXT")]),_c('span',{staticClass:"line"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }